/* Sura — collection grid layout switcher (<sura-grid-view>) */
(() => {
  const STORAGE_KEY = 'sura:collection-view';

  if (customElements.get('sura-grid-view')) return;

  class SuraGridView extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('.sura-cgrid');
      this.buttons = Array.from(this.querySelectorAll('[data-view]'));

      let saved = null;
      try { saved = localStorage.getItem(STORAGE_KEY); } catch (e) { /* storage blocked */ }

      if (saved && this.has(saved)) {
        this.apply(saved, false);
      } else {
        this.markPressed(this.root?.getAttribute('data-grid-view') || this.dataset.default);
      }

      this.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-view]');
        if (btn) this.apply(btn.dataset.view, true);
      });
    }

    has(view) {
      return this.buttons.some((b) => b.dataset.view === view);
    }

    apply(view, persist) {
      if (!this.root || !this.has(view)) return;
      this.root.setAttribute('data-grid-view', view);
      this.markPressed(view);
      if (persist) {
        try { localStorage.setItem(STORAGE_KEY, view); } catch (e) { /* storage blocked */ }
      }
    }

    markPressed(view) {
      this.buttons.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.view === view)));
    }
  }

  customElements.define('sura-grid-view', SuraGridView);
})();
